import { FULL_API_BASE_URL  } from "../Config/Config";

const EndPoints = {
  TopicsByChapterList: `${FULL_API_BASE_URL}/get-topics-by-chapter-list/`,
  DppQuestionPaper: `${FULL_API_BASE_URL}/get-dpp-question-paper/`,
  CreateDppSchedule: `${FULL_API_BASE_URL}/create-dpp-schedule/`,
  GetCourses: `${FULL_API_BASE_URL}/get-courses/`,
  GetSubjectsByCourse: `${FULL_API_BASE_URL}/get-subjects-by-course/`,
  GetChaptersBySubject: `${FULL_API_BASE_URL}/get-chapters-by-subject/`,
  GetBatchByCourse: `${FULL_API_BASE_URL}/get-batch-name-by-course-id/`,
  GetClasses: `${FULL_API_BASE_URL}/get-classes/`,
  GetDPPScheduleDetails: `${FULL_API_BASE_URL}/get-dpp-schedule-details-by-dpp-schedule-id/`,
  GetQuestionPaperList: `${FULL_API_BASE_URL}/get-ques-paper-list/`,
  GetInstructionTemplateList: `${FULL_API_BASE_URL}/get-dpp-instructions-template-list/`,
  PutUpdateDppSchedule: `${FULL_API_BASE_URL}/update-dpp-schedule/`,
  PutCancelDppSchedule: `${FULL_API_BASE_URL}/cancel-dpp-schedule/`,
  GetStudentProfileDetails: `${FULL_API_BASE_URL}/get-student-profile-details/`,
  GetStudentProgressCard: `${FULL_API_BASE_URL}/get-rpt-student-progress-card/`,
  GetStudentNotes: `${FULL_API_BASE_URL}/get-student-notes/`,
  GetStudentAttendance: `${FULL_API_BASE_URL}/get-student-attendance/`,
  GetTestNamebyBatch: `${FULL_API_BASE_URL}/get-test-detail-by-batch-id/`,
  PostTestMarksCorrectionv3: `${FULL_API_BASE_URL}/test-marks-correction-v3/`,
  GetTestSummarybyBatch: `${FULL_API_BASE_URL}/get-test-summary-from-batch-id/`,
  GetQuestionsfromSetName: `${FULL_API_BASE_URL}/get-questions-by-set-name/`,
  CancelDppSchedule: `${FULL_API_BASE_URL}/cancel-dpp-schedule/`,
  GetTestSchedulebyId: `${FULL_API_BASE_URL}/get-test-schedule-details-by-test-schedule-id/`,
  GetTestSchedulebyIdv1: `${FULL_API_BASE_URL}/get-test-schedule-details-by-test-schedule-id-v1/`,
  PostGenerateTestCode: `${FULL_API_BASE_URL}/generate-test-code/`,
  AddStudentNote: `${FULL_API_BASE_URL}/add-student-notes/`,
  PaperDetailsReview: `${FULL_API_BASE_URL}/get-ques-paper-details-for-review/`,
  CreateQuestionPaperReviewHistory: `${FULL_API_BASE_URL}/create-question-paper-review-history/`,
  GetEmployeeBySearchKey: `${FULL_API_BASE_URL}/get-employee-by-search-key/`,
  GetRoles: `${FULL_API_BASE_URL}/get-roles/`,
  PatchDeactivateUser: `${FULL_API_BASE_URL}/deactivate-user/`,
  GetUsersDashboardDetails: `${FULL_API_BASE_URL}/get-users-dashboard-details/`,
  GetRolesByUserID: `${FULL_API_BASE_URL}/get-roles-by-user-id/`,
  ActivateDeactivateUser: `${FULL_API_BASE_URL}/activate-deactivate-user/`,
  UpdateUser: `${FULL_API_BASE_URL}/update-user/`,
  GetAllUserGroups: `${FULL_API_BASE_URL}/get-all-user-groups/`,
  GetUserGroupMembersById: `${FULL_API_BASE_URL}/get-user-group-members-by-id/`,
  GetEmployeeForGroup: `${FULL_API_BASE_URL}/search-emp-for-group/`,
  DeactivateUserGroup: `${FULL_API_BASE_URL}/deactivate-user-group/`,
  UpdateUserGroup: `${FULL_API_BASE_URL}/update-user-group/`,
  BranchList: `${FULL_API_BASE_URL}/get-branch-list/`,
  CreateUserGroup: `${FULL_API_BASE_URL}/create-user-group/`,
  LogOutUser: `${FULL_API_BASE_URL}/logout-web/`,
  TrackerOrTransactionAudit: `${FULL_API_BASE_URL}/create-transaction-audit/`,
  NotificationConfigurationDashboard: `${FULL_API_BASE_URL}/get-notification-dashboard-list/`,
  NotificationConfigByScreenId: `${FULL_API_BASE_URL}/get-notification-config-by-branch-id/`,
  UPDATE_NOTIFICATION_CONFIG_API: `${FULL_API_BASE_URL}/update-notification-config`,
  GET_USER_AND_GROUPS_SEARCH_KEY: `${FULL_API_BASE_URL}/get-user-n-user-groups-for-role-by-search-key`,
  CLIENT_LANDING_PAGE_INFO_V2: `${FULL_API_BASE_URL}/client-landing-page-info-web-v2/`,
  LoginUser: `${FULL_API_BASE_URL}/login`,
  GetDppQuestionPaper: `${FULL_API_BASE_URL}/get-dpp-question-paper/`,
  GetDppScheduleByQuesPaperId: `${FULL_API_BASE_URL}/get-dpp-schedule-by-ques-paper-id/`,
  GetCoursePlan: `${FULL_API_BASE_URL}/get-course-plan/`,
  // CreateDppSchedule: `${FULL_API_BASE_URL}/create-dpp-schedule/`,
  GetDppScheduleDashboard: `${FULL_API_BASE_URL}/get-dpp-schedule-dashboard/`,

  //MCQ ENDPOINTS
  // PRISM_GET_ALL_MCQ_OF_DAY_BY_COURSE: `${FULL_API_BASE_URL}/get-all-mcq-of-day-by-course`,
  PRISM_GET_ALL_MCQ_OF_DAY_BY_COURSE: `${FULL_API_BASE_URL}/get-all-mcq-of-day-by-course/`,
  PRISM_CREATE_MCQ_SCHEDULE: `${FULL_API_BASE_URL}/create-mcq-schedule/`,
  PRISM_GET_CURRENT_DATETIME: `${FULL_API_BASE_URL}/get-current-datetime/`,

  
  APP_TOKEN: `${FULL_API_BASE_URL}/app-token`,
  PRISM_DELETE_MCQ_SCHEDULE: `${FULL_API_BASE_URL}/delete-mcq-schedule/`,
  PRISM_GET_COURSES: `${FULL_API_BASE_URL}/get-courses/`,
  PRISM_GET_SUBJECTS_BY_COURSE: `${FULL_API_BASE_URL}/get-subjects-by-course/`,
  PRISM_GET_CHAPTERS_BY_SUBJECT: `${FULL_API_BASE_URL}/get-chapters-by-subject/`,
  PRISM_GET_CHAPTERS_BY_SUBJECT_CB: `${FULL_API_BASE_URL}/get-chapters-by-subject-cb/`,
  PRISM_GET_CHAPTERS_BY_SUBJECT_IDS: `${FULL_API_BASE_URL}/get-chapters-by-subject-ids/`,
  PRISM_GET_TOPICS_BY_CHAPTER_LIST: `${FULL_API_BASE_URL}/get-topics-by-chapter-list/`,
  PRISM_GET_TOPICS_BY_CHAPTER: `${FULL_API_BASE_URL}/get-topics-by-chapter/`,
  PRISM_QUESTION_BANK_STATUS: `${FULL_API_BASE_URL}/question-bank/status/`,
  PRISM_IMPORT_QUESTIONS: `${FULL_API_BASE_URL}/question-bank/import/`,
  PRISM_SYNC_HISTORY: `${FULL_API_BASE_URL}/sync-history/`,
  PRISM_GET_PARSE_QUES_SET_ALL_CB: `${FULL_API_BASE_URL}/get-parse-ques-set-all-cb/`,
  PRIM_MANAGE_USER_FAVOURITE: `${FULL_API_BASE_URL}/manage-user-favourite`,
  PRISM_GET_PATTERN_DETAILS: `${FULL_API_BASE_URL}/get-pattern-details/`,
  PRISM_GET_CURATE_QUES_PAPER_DETAILS_BY_PAPER_ID: `${FULL_API_BASE_URL}/get-curate-ques-paper-details-by-paper-id/`,
  PRISM_UPDATE_CURATE_QUES_PAPER_DETAILS_BY_PAPER_ID: `${FULL_API_BASE_URL}/update-curate-ques-paper-details-by-paper-id/`,
  PRISM_DELETE_CURATE_QUESTION_PAPER: `${FULL_API_BASE_URL}/delete-curate-question-paper/`,
  PRISM_CURATE_QUESTION_PAPER: `${FULL_API_BASE_URL}/curate-question-paper/`,
  PRISM_GET_TEST_SERIES_LIST_BY_BRANCH: `${FULL_API_BASE_URL}/get-test-series-list-by-branch/`,
  PRISM_GET_ASSIGNOR_DASHBOARD_DETAILS: `${FULL_API_BASE_URL}/get-assignor-dashboard-details/`,
  PRISM_CHECK_DUPLICATE_LAYOUT: `${FULL_API_BASE_URL}/check-duplicate-layout/`,
  PRISM_GET_FACULTY_LIST_BY_SEARCHKEY: `${FULL_API_BASE_URL}/get-faculty-list-by-searchkey/`,
  PRISM_GET_ASSIGNEE_DASHBOARD_DETAILS: `${FULL_API_BASE_URL}/get-assignee-dashboard-details/`,
  PRISM_GET_PARSE_TAGS_ALL: `${FULL_API_BASE_URL}/get-parse-tags-all/`,
  PRISM_GET_QUES_PAPER_LAYOUT_DETAIL: `${FULL_API_BASE_URL}/get-ques-paper-layout-detail/`,
  PRISM_GET_QUES_PAPER_BY_ASSIGNEE_DRAFT: `${FULL_API_BASE_URL}/get-ques-paper-by-assignee-draft/`,
  PRISM_GET_SUBJECT_TEMPLATE_LIST_BY_USER: `${FULL_API_BASE_URL}/get-subject-template-list-by-user/`,
  PRISM_GET_QUESTIONS_BY_TAG_FILTERS: `${FULL_API_BASE_URL}/get-questions-by-tag-filters/`,
  PRISM_CREATE_QUES_PAPER_BY_ASSIGNEE: `${FULL_API_BASE_URL}/create-ques-paper-by-assignee/`,
  PRISM_CREATE_SUBJECT_TEMPLATE_BY_USER: `${FULL_API_BASE_URL}/create-subject-template-by-user/`,
  PRISM_GET_SUBJECT_TEMPLATE_DETAILS_BY_TEMPLATE_ID: `${FULL_API_BASE_URL}/get-subject-template-details-by-template-id/`,
  PRISM_GET_QUES_OPTIONS_BY_QUES_ID_LIST: `${FULL_API_BASE_URL}/get-ques-options-by-ques-id-list/`,
  PRISM_GET_REVIEWER_DASHBOARD_DETAILS: `${FULL_API_BASE_URL}/get-reviewer-dashboard-details/`,
  PRISM_GET_REVIEWER_DASHBOARD_DETAILS_C: `${FULL_API_BASE_URL}/c`,
  PRISM_GET_DPP_SCHEDULE_DASHBOARD: `${FULL_API_BASE_URL}/get-dpp-schedule-dashboard/`,
  PRISM_GET_COURSE_PLAN: `${FULL_API_BASE_URL}/get-course-plan/`,
  PRISM_GET_PLAN_DPP_LEVEL_VIEW: `${FULL_API_BASE_URL}/get-plan-dpp-level-view/`,
  PRISM_GET_DPP_FOLDER_STRUCTURE: `${FULL_API_BASE_URL}/get-dpp-folder-structure/`,
  PRISM_GET_TEST_FOLDER_STRUCTURE: `${FULL_API_BASE_URL}/get-test-folder-structure/`,

  PRISM_GET_DPP_SCHEDULE_BY_QUES_PAPER_ID: `${FULL_API_BASE_URL}/get-dpp-schedule-by-ques-paper-id/`,
  PRISM_GET_DPP_INSTRUCTIONS_TEMPLATE_LIST: `${FULL_API_BASE_URL}/get-dpp-instructions-template-list/`,
  PRISM_GET_DPP_QUESTION_PAPER: `${FULL_API_BASE_URL}/get-dpp-question-paper/`,
  PRISM_CREATE_DPP_SCHEDULE: `${FULL_API_BASE_URL}/create-dpp-schedule/`,
  PRISM_GET_QUESTIONS_BY_IDS: `${FULL_API_BASE_URL}/get-questions-by-ids`,
  PRISM_GET_TEST_SCHEDULE_DASHBOARD: `${FULL_API_BASE_URL}/get-test-schedule-dashboard/`,

  
  
  // TEST SCHEDULE EDIT ENDPOINTS
  PRISM_GET_TEST_SCHEDULE_DETAILS_BY_ID: `${FULL_API_BASE_URL}/get-test-schedule-details-by-test-schedule-id-v1/`,
  PRISM_POST_GENERATE_TEST_CODE: `${FULL_API_BASE_URL}/generate-test-code/`,
  PRISM_GET_SHARED_STUDENT_GROUPS: `${FULL_API_BASE_URL}/get-shared-student-groups/`,
  PRISM_GET_QUES_PAPER_LIST: `${FULL_API_BASE_URL}/get-ques-paper-list/`,
  PRISM_GET_SCOPES_DETAILS_ALL: `${FULL_API_BASE_URL}/get-scopes-details-all/`,
  PRISM_GET_MARKING_SCHEME_LIST_ACTIVE: `${FULL_API_BASE_URL}/get-marking-scheme-list-active/`,
  PRISM_GET_FACULTY_LIST: `${FULL_API_BASE_URL}/get-faculty-list/`,
  PRISM_GET_TEST_INSTRUCTIONS_TEMPLATE_LIST: `${FULL_API_BASE_URL}/get-test-instructions-template-list/`,
  PRISM_UPDATE_TEST_SCHEDULE: `${FULL_API_BASE_URL}/update-test-schedule-v1/`,
  PRISM_CANCEL_TEST_SCHEDULE: `${FULL_API_BASE_URL}/cancel-test-schedule/`,
  PRISM_GET_LIST_OF_SCOPES: `${FULL_API_BASE_URL}/get-list-of-scopes/`,
  // PRISM_GET_FULL_QUESTION_PAPER_BY_TEST_SCHEDULE_AND_SET: `${FULL_API_BASE_URL}/get-full-question-paper-by-test-shedule-id-and-set`,
  PRISM_GET_FULL_QUESTION_PAPER_FOR_TEST_BY_QUES_PAPER_AND_SET: `${FULL_API_BASE_URL}/get-full-question-paper-for-test-by-question-paper-id-and-set`,
  PRISM_GET_FULL_QUESTION_PAPER_FOR_DPP_BY_QUES_PAPER_AND_SET: `${FULL_API_BASE_URL}/get-full-question-paper-for-dpp-by-question-paper-id-and-set`,


  PRISM_GET_TEST_SCHEDULE_DETAILS_V1: `${FULL_API_BASE_URL}/get-test-schedule-details-by-test-schedule-id-v1/`,
  PRISM_GET_QUES_PAPER_LIST_V1: `${FULL_API_BASE_URL}/get-ques-paper-list/`,
  PRISM_GET_TEST_INSTRUCTIONS_TEMPLATE_LIST_V1: `${FULL_API_BASE_URL}/get-test-instructions-template-list/`,
  PRISM_GET_MARKING_SCHEME_LIST: `${FULL_API_BASE_URL}/get-marking-scheme-list-active/`,
  PRISM_CREATE_TEST_SCHEDULE_V1: `${FULL_API_BASE_URL}/create-test-schedule/`,
  PRISM_GET_TEST_LEVEL_VIEW: `${FULL_API_BASE_URL}/get-test-level-view/`,
  PRISM_GET_TEST_SCHEDULE_BY_QUES_PAPER_ID: `${FULL_API_BASE_URL}/get-test-schedule-by-ques-paper-id/`,
  PRISM_CREATE_TEST_SCHEDULE_APPROVAL: `${FULL_API_BASE_URL}/create-test-schedule-approval/`,
  PRISM_GET_TEST_SCHEDULE_BY_QUES_PAPER_ID_REVIEW: `${FULL_API_BASE_URL}/get-test-schedule-by-ques-paper-id-review/`,

  PRISM_GET_USERS_DASHBOARD_DETAILS: `${FULL_API_BASE_URL}/get-users-dashboard-details/`,
  PRISM_CHECK_USERNAME_AVAILABILITY: `${FULL_API_BASE_URL}/check-username-availability/`,
  PRISM_GET_EMPLOYEE_BY_ID: `${FULL_API_BASE_URL}/get-employee-by-id/`,
  PRISM_GET_EMPLOYEE_BY_SEARCH_KEY: `${FULL_API_BASE_URL}/get-employee-by-search-key/`,
  PRISM_UPDATE_APP_USER_GROUPS: `${FULL_API_BASE_URL}/update-app-user-groups/`,
  PRISM_ACTIVATE_DEACTIVATE_USER: `${FULL_API_BASE_URL}/activate-deactivate-user`,
  PRISM_SEARCH_EMP_FOR_GROUP: `${FULL_API_BASE_URL}/search-emp-for-group`,
  PRISM_GET_ALL_USER_GROUPS_SEARCH_KEY: `${FULL_API_BASE_URL}/get-all-user-groups-search-key`,
  PRISM_NEW_USER: `${FULL_API_BASE_URL}/new-user`,
  PRISM_GET_USER_GROUP_ROLE_SCREEN_REPORT_ACCESS_DETAILS_BY_USER_ID: `${FULL_API_BASE_URL}/get-user-group-role-screen-report-access-details-by-user-id`,
  PRISM_UPDATE_USER: `${FULL_API_BASE_URL}/update-user`,
  PRISM_GET_USER_GROUP_BY_USER_ID: `${FULL_API_BASE_URL}/get-user-group-by-user-id`,

  // EMPLOYEE REGISTRATION
  PRISM_GET_GENDER_LIST: `${FULL_API_BASE_URL}/get-gender-list/`,
  PRISM_GET_RELIGIONS: `${FULL_API_BASE_URL}/get-religions/`,
  PRISM_GET_SALUTATION: `${FULL_API_BASE_URL}/get-salutation/`,
  PRISM_GET_CATEGORY_LIST: `${FULL_API_BASE_URL}/get-category-list/`,
  PRISM_GET_DEPARTMENT: `${FULL_API_BASE_URL}/get-department/`,
  PRISM_GET_JOB_GRADE_LIST: `${FULL_API_BASE_URL}/get-job-grade-list/`,
  PRISM_GET_DESIGNATION_BY_SEARCH_KEY: `${FULL_API_BASE_URL}/get-designation-by-search-key/`,
  PRISM_GET_MANAGER_BY_SEARCH_KEY: `${FULL_API_BASE_URL}/get-manager-by-search-key/`,
  PRISM_GET_BLOOD_GROUP: `${FULL_API_BASE_URL}/get-blood-group/`,
  PRISM_GET_CITY_LIST_SEARCH_KEY: `${FULL_API_BASE_URL}/get-city-list-serach_key/`,
  PRISM_NEW_EMPLOYEE: `${FULL_API_BASE_URL}/new-employee`,
  
  PRISM_TOKEN: `${FULL_API_BASE_URL}/token`,
  PRISM_APP_TOKEN: `${FULL_API_BASE_URL}/app-token`,
  PRISM_CHANGE_PASSWORD: `${FULL_API_BASE_URL}/change-password`,
  PRISM_RESET_NEW_PASSWORD: `${FULL_API_BASE_URL}/reset-new-password`,
  PRISM_UPDATE_BRANCH_APP_SETTINGS: `${FULL_API_BASE_URL}/update-branch-app-settings`,
  PRISM_GET_BRANCH_APP_SETTINGS: `${FULL_API_BASE_URL}/get-branch-app-settings`,

  // ROLE
  PRISM_GET_ROLES: `${FULL_API_BASE_URL}/get-roles/`,
  PRISM_GET_REPORT_LIST_BY_SEARCH_KEY: `${FULL_API_BASE_URL}/get-report-list-by-search-key`,
  PRISM_NEW_ROLE_V2: `${FULL_API_BASE_URL}/new-role-v2`,
  PRISM_GET_ROLE_SCREEN_ACCESS_ALL: `${FULL_API_BASE_URL}/get-role-screen-access_all/`,
  PRISM_GET_ROLE_DETAILS_BY_ID: `${FULL_API_BASE_URL}/get-role-details-by-id/`,
  PRISM_GET_SCREEN_LIST_BY_ROLE_ID: `${FULL_API_BASE_URL}/get-screen-list-by-role-id`,
  PRISM_GET_REPORT_LIST_BY_ROLE_ID: `${FULL_API_BASE_URL}/get-report-list-by-role-id`,
  PRISM_UPDATE_ROLE_DETAILS: `${FULL_API_BASE_URL}/update-role-details`,
  PRISM_GET_BRANCH_LIST: `${FULL_API_BASE_URL}/get-branch-list`,
  PRISM_GET_APP_USERS_BY_ROLE_ID: `${FULL_API_BASE_URL}/get-app-users-by-role-id`,
  PRISM_GET_USER_N_USER_GROUPS_FOR_ROLE_BY_SEARCH_KEY: `${FULL_API_BASE_URL}/get-user-n-user-groups-for-role-by-search-key`,
  PRISM_UPDATE_ROLE_USER_N_USER_GROUPS: `${FULL_API_BASE_URL}/update-role-user-n-user-groups`,

  // user group
  PRISM_GET_ALL_USER_GROUPS: `${FULL_API_BASE_URL}/get-all-user-groups`,
  PRISM_CREATE_USER_GROUP: `${FULL_API_BASE_URL}/create-user-group`,
  PRISM_GET_USER_GROUP_MEMBERS_BY_ID: `${FULL_API_BASE_URL}/get-user-group-members-by-id`,
  PRISM_UPDATE_USER_GROUP_MEMBERS: `${FULL_API_BASE_URL}/update-user-group-members`,
  PRISM_GET_ALL_ROLES_BY_SEARCH_KEY: `${FULL_API_BASE_URL}/get-all-roles-by-search-key/`,
  PRISM_GET_ROLES_BY_USER_GROUP_ID: `${FULL_API_BASE_URL}/get-roles-by-user-group-id`,
  PRISM_UPDATE_USER_GROUP_ROLES: `${FULL_API_BASE_URL}/update-user-group-roles`,
  PRISM_DEACTIVATE_USER_GROUP: `${FULL_API_BASE_URL}/deactivate-user-group`,
  PRISM_UPDATE_USER_GROUP_DETAILS: `${FULL_API_BASE_URL}/update-user-group-details`,

  // QUESTION BANK
  PRISM_GET_QUES_LIST_FOR_REVIEW: `${FULL_API_BASE_URL}/get-ques-list-for-review/`,
  PRISM_GET_PARSE_QUES_HISTORY: `${FULL_API_BASE_URL}/get-parse-ques-history/`,
  PRISM_GET_PARSED_QUESTIONS_V2: `${FULL_API_BASE_URL}/get-parsed-questions-v2/`,
  PRISM_UPDATE_PARSE_QUESTIONS: `${FULL_API_BASE_URL}/update-parse-questions/`,
  PRISM_GET_PARSE_QUES_SET_ALL: `${FULL_API_BASE_URL}/get-parse-ques-set-all/`,
  PRISM_GET_PARSE_QUES_REVIEW_REQUESTS: `${FULL_API_BASE_URL}/get-parse-ques-review-requests/`,
  PRISM_CREATE_PARSE_QUES_REVIEW_REQUEST: `${FULL_API_BASE_URL}/create-parse-ques-review-request/`,
  
  // TIP OF THE DAY
  GET_TIP_INVENTORY_DASHBOARD: `${FULL_API_BASE_URL}/get-all-tip-of-day`,
  GET_ALL_TIP_OF_DAY: `${FULL_API_BASE_URL}/get-tip-of-day-list`,
  CREATE_TIP_OF_THE_DAY_SCHEDULE: `${FULL_API_BASE_URL}/create-tip-of-the-day-schedule/`,
  GET_CURRENT_DATETIME: `${FULL_API_BASE_URL}/get-current-datetime/`,
  SEND_PUSH_NOTIFICATION: `${FULL_API_BASE_URL}/send-push-to-all-by-firebase-id`,
  GET_ALL_COURSE_PLANS: `${FULL_API_BASE_URL}/get-all-course-plans/`,
  GET_SUBSCRIBER_DETAILS_BY_SEARCH_KEY: `${FULL_API_BASE_URL}/get-subscriber-details-by-search-key/`,
};

export default EndPoints;